import { render, staticRenderFns } from "./noPay.vue?vue&type=template&id=d1d2490c&scoped=true&lang=pug&"
import script from "./noPay.vue?vue&type=script&lang=js&"
export * from "./noPay.vue?vue&type=script&lang=js&"
import style0 from "./noPay.vue?vue&type=style&index=0&id=d1d2490c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d2490c",
  null
  
)

export default component.exports